import type { SVGProps } from "react";

const JoinIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="26"
      height="11"
      viewBox="0 0 26 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.52 7.312C6.52 9.076 5.44 10.084 3.7 10.084C2.572 10.084 1.66 9.604 0.952 8.776L1.828 7.432C2.416 8.056 3.088 8.368 3.604 8.368C4.228 8.368 4.612 7.984 4.612 7.264V3.208H1.72V1.6H6.52V7.312ZM11.097 3.484C13.161 3.484 14.553 4.792 14.553 6.772C14.553 8.74 13.161 10.072 11.097 10.072C9.02097 10.072 7.62897 8.74 7.62897 6.772C7.62897 4.792 9.02097 3.484 11.097 3.484ZM11.097 5.02C10.137 5.02 9.47697 5.74 9.47697 6.796C9.47697 7.852 10.137 8.572 11.097 8.572C12.045 8.572 12.705 7.852 12.705 6.796C12.705 5.74 12.045 5.02 11.097 5.02ZM16.6987 0.784C17.2267 0.784 17.5987 1.168 17.5987 1.708C17.5987 2.236 17.2267 2.632 16.6987 2.632C16.1707 2.632 15.7987 2.236 15.7987 1.708C15.7987 1.168 16.1707 0.784 16.6987 0.784ZM15.7747 3.544H17.6227V10H15.7747V3.544ZM23.4758 3.472C24.9158 3.472 25.8398 4.432 25.8398 5.944V10H23.9918V6.484C23.9918 5.668 23.5118 5.164 22.7198 5.164C21.7958 5.176 21.2438 5.872 21.2438 6.82V10H19.3958V3.544H21.2438V4.672C21.6998 3.868 22.4678 3.484 23.4758 3.472Z"
        fill="white"
      />
    </svg>
  );
};

export default JoinIcon;
